<template>
  <div class="tax-invoice-request-display">
    <div class="card card-default mb-4">
      <h4 
        class="card-header" 
        v-html="title" />
      <div class="card-body">
        <p class="text-muted" v-if="asbestosReport.StaffMember">
          {{ asbestosReport.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ asbestosReport.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="asbestosReport.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: asbestosReport.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: asbestosReport.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="asbestosReport.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: asbestosReport.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: asbestosReport.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="asbestosReport.SentEmails.length">
          <sent-email
            v-for="email in asbestosReport.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + asbestosReport.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + asbestosReport.uuid + '?m=AsbestosReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !asbestosReport.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!asbestosReport.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: asbestosReport.ReportPdf ? asbestosReport.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!asbestosReport.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          class="my-1 btn btn-lime" 
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + asbestosReport.uuid + '?t=AsbestosReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteAsbestosReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_ASBESTOS_REPORT,
    GENERATE_ASBESTOS_PDF,
    SEND_ASBESTOS_REPORT
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'AsbestosReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.asbestosReport.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.asbestosReport.ReportPdf) {
          return this.asbestosReport.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.asbestosReport.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.asbestosReport.complete && !this.asbestosReport.TaxInvoiceRequestUuid
      },
      title () {
        if (this.asbestosReport.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.asbestosReport.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      asbestosReport () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteAsbestosReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.asbestosReport.uuid,
          reportType: 'AsbestosReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_ASBESTOS_PDF, this.asbestosReport)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_ASBESTOS_REPORT, this.asbestosReport.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_ASBESTOS_REPORT, this.asbestosReport.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/AsbestosReport.vue